//=============================================================================================================================
//
// 														SCENE DESC
//
//=============================================================================================================================
//======================
// 		MESHES

import { Material, Mesh } from "../../../basePass";
import { GTexturePool } from "../../../core/texturePool";
import { GetVec3, Matrix4x4, Vector3 } from "../../../core/types";
import { SceneBase } from "../../scene";
import { PayneSceneLightSwitch } from "./lightSwitch";

//======================
export function InitializeHotlineMeshes(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    // const phoneCenterHeight = 0.0;
    const sceneScale = 1.0;

    //Wall
    {
        const woodMaterial = new Material();
        {
            const matName = `wall`;
            woodMaterial.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
            woodMaterial.TextureScale = 4.0;
        }
        //Front
        {
            const mesh = new Mesh();
            mesh.GeneratePlane(gl);
            const size = 10.0;
            mesh.Scale.Set3(size, size, 1);
            mesh.Position.y += 2.0;
            mesh.Material = woodMaterial;
            scene.HotlineMeshesArr.push(mesh);
        }
    }

    {
        //Table
        const table = new Mesh();
        {
            table.Name = "PhoneTable";

            {
                table.bNormalizeScale = true;
                table.Scale.SetSame(3.5 * sceneScale);
                table.Scale.x = 2.75;
                table.Scale.z = 2.0;
                table.Position.Set3(0.0, 0.0, 0.0 - table.Scale.z * 0.5 - 0.01);
                table.Position.y -= table.Scale.y;

                const preTransformMat = new Matrix4x4();
                const euler = new Vector3(0, 0, 0);
                Matrix4x4.ConstructRotationMatrix(euler, preTransformMat);

                const path = Mesh.GMeshesLocationFolder + `tableWood/`;
                table.LoadMesh(gl, path + `table.gltf`, 2, preTransformMat, false);

                const matName = `mat`;
                table.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
            }

            scene.HotlineMeshesArr.push(table);
        }

        const phone1 = new Mesh();
        scene.MeshPhone = phone1;

        phone1.Name = "PhoneBody";

        phone1.bNormalizeScale = true;

        phone1.Scale.SetSame(0.7 * sceneScale);

        phone1.Position.Set3(0.0, 0.0, table.Position.z - 0.5);
        phone1.Position.y += phone1.Scale.y * 0.45;
        //phone1.Orientation.z = Math.PI;

        const preTransformMat = new Matrix4x4();
        const euler = new Vector3(0, 0, Math.PI);
        Matrix4x4.ConstructRotationMatrix(euler, preTransformMat);

        const path = Mesh.GMeshesLocationFolder + `phone/`;
        phone1.LoadMesh(gl, path + `body.gltf`, 0, preTransformMat, true);

        const matName = `mat`;
        phone1.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
        /* phone1.Material.bisEmmiter = true;
        phone1.Material.Brightness = 5.0; */

        scene.HotlineMeshesArr.push(phone1);

        //Phone Handle
        {
            const phone2 = new Mesh();
            phone2.Name = "PhonHandle";
            scene.MeshPhoneHandle = phone2;

            phone2.bNormalizeScale = true;

            phone2.Scale.Set(phone1.Scale);
            phone2.Scale.Mul(1.275);
            phone2.Orientation.Set(phone1.Orientation);
            phone2.Position.Set(phone1.Position);
            const parentPosOffset = GetVec3(0.0, 0.35, 0.6);
            parentPosOffset.Mul(phone1.Scale.x);
            phone2.Position.Add(parentPosOffset);
            /* phone2.Position.y += 0.1 * phone2.Scale.y;
            phone2.Position.z += 0.05 * phone2.Scale.z; */

            phone2.LoadMesh(gl, path + `handle.gltf`, 0, preTransformMat, true);

            phone2.Material = phone1.Material;

            scene.HotlineMeshesArr.push(phone2);

            {
                scene.MeshPhoneHandleSpatialController.PositionWS.Set(phone2.Position);
                scene.MeshPhoneHandleSpatialController.PositionWS.y += 0.2;
            }
        }

        table.Position.z = -1.4;
    }

    {
        //table cloth
        const mesh = new Mesh();

        mesh.bNormalizeScale = true;
        mesh.Scale.SetSame(2.5);
        mesh.Scale.x = 2.2;
        mesh.Scale.y *= 0.25;
        mesh.Scale.z = 1.2;
        //mesh.Position.y -= 0.1;
        mesh.Orientation.z = 3.14;
        //mesh.Position.z -= 0.1;
        mesh.Position.z = scene.MeshPhone.Position.z + 0.15;
        mesh.Position.y = -0.11;
        mesh.Position.x -= 0.04;

        const path = Mesh.GMeshesLocationFolder + `tableWood/cover/`;
        mesh.LoadMesh(gl, path + `cover.gltf`, 0, null, false);

        const matName = `mat`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);

        scene.HotlineMeshesArr.push(mesh);
    }

    //TEST
    /* {
        //sphere
        const mesh = new Mesh();

        mesh.bNormalizeScale = true;
        mesh.Scale.SetSame(1.5);
        mesh.Position.Set3(0.0, 3.0, -2.0);

        const path = Mesh.GMeshesLocationFolder + `test/`;
        mesh.LoadMesh(gl, path + `hpsphere.gltf`, 0, null, false);

        const matName = `brushMetal`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);

        scene.HotlineMeshesArr.push(mesh);
    } */

    //Wall Lamp
    const LoadWallLamp = (spotPos: Vector3, meshIndex: number) => {
        const scaleAll = 4.0;

        const outMeshArr: Mesh[] = [];

        //sphere
        const mesh = new Mesh();

        mesh.Name = meshIndex + `Lamp0`;

        mesh.Position.x = spotPos.x;
        mesh.Position.y = spotPos.y + 0.825;
        //mesh.Position.z = -0.18;
        mesh.Position.z = -0.2;

        mesh.Orientation.z = Math.PI * 0.5;

        mesh.Scale.SetSame(scaleAll);

        const path = Mesh.GMeshesLocationFolder + `wallLamp/`;
        mesh.LoadMesh(gl, path + `scene4.gltf`, 0, null, false);

        const matName = `mat`;
        if (meshIndex == 0) {
            mesh.Material.InitTextures(gl, matName + `DFS2`, matName + `NRM2`, matName + `RGH2_R8`, false, path);
        }
        //mesh.Material.bisEmmiter = true;
        mesh.Material.Metalness = 0.6;

        scene.HotlineMeshesArr.push(mesh);

        outMeshArr[0] = mesh;

        {
            const mesh2 = new Mesh();
            mesh2.Name = meshIndex + "Lamp1";
            mesh2.Position.Set(mesh.Position);
            mesh2.Orientation.Set(mesh.Orientation);
            mesh2.Scale.Set(mesh.Scale);
            mesh2.LoadMesh(gl, path + `scene4.gltf`, 3, null, false);

            mesh2.Position.y -= 0.06;
            mesh2.Position.z -= 0.21;

            if (meshIndex == 0) {
                mesh2.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
            }
            //mesh2.Material.bisEmmiter = true;
            mesh2.Material.Metalness = 0.6;

            scene.HotlineMeshesArr.push(mesh2);

            outMeshArr[1] = mesh2;
        }

        {
            const mesh2 = new Mesh();
            mesh2.Name = meshIndex + "LampLight1";
            mesh2.Position.Set(mesh.Position);
            mesh2.Orientation.Set(mesh.Orientation);
            mesh2.Scale.Set(mesh.Scale);
            mesh2.Scale.y = scaleAll + 0.35;
            mesh2.LoadMesh(gl, path + `scene4.gltf`, 1, null, false);

            mesh2.Position.y -= 0.44;
            mesh2.Position.z -= 0.21;

            //mesh2.Material.Init(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
            if (meshIndex == 0) {
                mesh2.Material.AlbedoTexture = GTexturePool.CreateTexture(
                    gl,
                    false,
                    matName + `Em`,
                    true,
                    true,
                    false,
                    null,
                    path,
                );
            }
            mesh2.Material.Brightness = 0.8;
            mesh2.Material.bisEmmiter = true;

            scene.HotlineMeshesArr.push(mesh2);

            const mesh3 = new Mesh();
            mesh3.Name = meshIndex + "LampLight2";
            mesh3.Position.Set(mesh2.Position);
            mesh3.Orientation.Set(mesh2.Orientation);
            mesh3.Scale.Set(mesh2.Scale);
            mesh3.LoadMesh(gl, path + `scene4.gltf`, 2, null, false);
            mesh3.Material = mesh2.Material;
            scene.HotlineMeshesArr.push(mesh3);

            outMeshArr[2] = mesh2;
            outMeshArr[3] = mesh3;
        }
        return outMeshArr;
    };

    const outMeshArr1 = LoadWallLamp(SceneBase.UniformBuffer.Params.SpotlightPos3, 0);
    const spot2Pos = GetVec3(0, 0, 0);
    spot2Pos.Set(SceneBase.UniformBuffer.Params.SpotlightPos3);
    spot2Pos.x *= -1.0;
    spot2Pos.x += 0.85;

    scene.LampLeftAABB.Position.Set(SceneBase.UniformBuffer.Params.SpotlightPos3);
    scene.LampRightAABB.Position.Set(spot2Pos);

    const outMeshArr2 = LoadWallLamp(spot2Pos, 1);
    for (let i = 0; i < 4; i++) {
        outMeshArr2[i].VAO = outMeshArr1[i].VAO;
        outMeshArr2[i].Material.AlbedoTexture = outMeshArr1[i].Material.AlbedoTexture;
        outMeshArr2[i].Material.NormalTexture = outMeshArr1[i].Material.NormalTexture;
        outMeshArr2[i].Material.RoughnessTexture = outMeshArr1[i].Material.RoughnessTexture;
    }
    for (let i = 0; i < 4; i++) {
        scene.MeshLampRightArr[i] = outMeshArr2[i];
        scene.MeshLampLeftArr[i] = outMeshArr1[i];
    }

    //Frame Wood
    {
        const mesh = new Mesh();

        mesh.Name = "WoodFrame";

        const path = Mesh.GMeshesLocationFolder + `woodFrame/`;
        mesh.bNormalizeScaleAllAxes = true;
        mesh.Orientation.y = Math.PI;
        mesh.Orientation.x = Math.PI * 0.5;
        mesh.Scale.x = 2.2;
        mesh.Scale.y = 0.1;
        mesh.Scale.z = 2.7;
        mesh.LoadMesh(gl, path + `sceneNew.gltf`, 0);

        mesh.Position.Set3(0.0, 3.0, -0.15);

        const matName = `mat`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
        mesh.Material.TextureScale = 2.0;
        scene.HotlineMeshesArr.push(mesh);

        scene.MeshDestrPainting.push(mesh);

        {
            const mesh2 = new Mesh();

            mesh2.Name = "GoldFrame";

            mesh2.bNormalizeScaleAllAxes = true;
            mesh2.Orientation.Set(mesh.Orientation);
            mesh2.Scale.Set(mesh.Scale);
            mesh2.Scale.y = 1.7;

            mesh2.Scale.x *= 0.910371;
            mesh2.Scale.z *= 0.922724;

            mesh2.LoadMesh(gl, path + `sceneNew.gltf`, 1);

            mesh2.Position.Set(mesh.Position);
            mesh2.Position.z -= 0.02;

            if (1) {
                mesh2.Material.InitTextures(
                    gl,
                    matName + `DFS`,
                    matName + `NRM`,
                    matName + `RGH_R8`,
                    false,
                    Mesh.GMeshesLocationFolder + `goldFrame/`,
                );
                mesh2.Material.Metalness = 0.6;
            } else {
                mesh2.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
                mesh2.Material.Metalness = 0.0;
            }

            mesh2.Material.TextureScale = 2.0;
            scene.HotlineMeshesArr.push(mesh2);

            scene.MeshDestrPainting.push(mesh2);
        }
    }

    //Painting
    {
        const mesh = new Mesh();
        mesh.Name = "Painting";
        mesh.GeneratePlane(gl);
        mesh.Position.Set3(0.0, 3.0, -0.1);
        mesh.Scale.Set3(2.2, 2.7, 1.0);
        mesh.Scale.x *= 0.9;
        mesh.Scale.y *= 0.9;

        scene.PaintingAABB.Position.Set(mesh.Position);
        scene.PaintingFrameAABB.Position.Set(mesh.Position);

        scene.PaintingAABB.Extent.Set(mesh.Scale);
        scene.PaintingAABB.Extent.z = 0.05;
        scene.PaintingFrameAABB.Extent.Set(mesh.Scale);
        scene.PaintingFrameAABB.Extent.z = 0.05;
        scene.PaintingFrameAABB.Extent.x /= 0.9;
        scene.PaintingFrameAABB.Extent.y /= 0.9;
        /* scene.PaintingFrameAABB.Extent.x += 0.1;
        scene.PaintingFrameAABB.Extent.y += 0.1; */

        const matName = `bluePaint`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
        mesh.Material.AlbedoTexture = GTexturePool.CreateTexture(
            gl,
            false,
            `paintingNicole1`,
            true,
            true,
            false,
            null,
            null,
        );
        mesh.Material.bisEmmiter = true;
        mesh.Material.Brightness = 0.01;
        //mesh.Material.bisEmmiter = true;
        //mesh.Material.Metalness = 0.9;

        scene.HotlineMeshesArr.push(mesh);

        scene.NicPaintingMesh = mesh;
    }

    //Pills
    if (1) {
        const mesh = scene.MeshPills;

        mesh.Name = "Pills";

        const path = Mesh.GMeshesLocationFolder + `pills/`;
        //mesh.bNormalizeScaleAllAxes = true;
        mesh.bNormalizeScale = true;
        //mesh.Orientation.y = Math.PI;
        mesh.Orientation.x = -Math.PI * 0.5;
        mesh.Orientation.z = -0.7;
        /* mesh.Scale.x = 2.2;
        mesh.Scale.y = 0.1;
        mesh.Scale.z = 2.7; */
        mesh.Scale.Mul3(0.25, 0.25, 0.35);
        mesh.LoadMesh(gl, path + `scene.gltf`, 0);

        mesh.Position.Set3(0.0, 2.0, -1.15);

        const matName = `mat`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
        scene.HotlineMeshesArr.push(mesh);
    }

    //wings
    {
        const mesh = new Mesh();

        mesh.Name = "WingLefy";

        mesh.bNormalizeScale = true;
        mesh.Scale.SetSame(4.55);
        mesh.Scale.z *= 1.5;
        mesh.Orientation.y = 0.14;
        mesh.Orientation.z = -2.79;
        mesh.Position.Set3(0.0, 3.0, -0.5);

        mesh.Position.x = -4.2;

        const path = Mesh.GMeshesLocationFolder + `wings/`;
        mesh.LoadMesh(gl, path + `wR.gltf`, 0, null, false);

        const matName = `mat`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);

        const mesh2 = new Mesh();

        mesh2.Name = "WingRight";

        mesh2.bNormalizeScale = true;
        mesh2.Scale.Set(mesh.Scale);
        mesh2.Orientation.y = -0.14;
        mesh2.Orientation.z = 2.79;
        mesh2.Position.Set3(0.0, 3.0, -0.5);

        mesh2.Position.x = -mesh.Position.x;

        mesh2.LoadMesh(gl, path + `wL.gltf`, 0, null, false);

        mesh2.Material = mesh.Material;

        /* scene.HotlineMeshesArr.push(mesh);
        scene.HotlineMeshesArr.push(mesh2); */

        scene.MeshWingLeft = mesh;
        scene.MeshWingRight = mesh2;
    }

    //lamp
    {
        /* const mesh = new Mesh();

        mesh.Name = "Lamp";

        mesh.bNormalizeScale = true;
        mesh.Scale.SetSame(2.0);
        mesh.Orientation.x = -Math.PI * 0.5;

        mesh.Position.x = 2.64;
        mesh.Position.y = 1.06;
        mesh.Position.z = -1.26;

        const path = Mesh.GMeshesLocationFolder + `lamp/`;
        mesh.LoadMesh(gl, path + `scene.gltf`, 0, null, false);

        const matName = `mat`;
        mesh.Material.Init(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
        scene.HotlineMeshesArr.push(mesh); */
    }
}
export function InitializeMeshes(gl: WebGL2RenderingContext, scene: PayneSceneLightSwitch) {
    //Add Meshes

    //Bird
    {
        const mesh = scene.MeshBird;

        mesh.Position.Set3(-3.57, -1.55, -5.27);
        //const pos2 = new Vector3(-3.0, -1.4, -6.5)
        mesh.Scale.SetSame(3.0);

        mesh.Name = "Bird";

        const preTransformMat = new Matrix4x4();
        const euler = new Vector3(0, 0, 0);
        /* euler.z = Math.PI;
            euler.x = Math.PI * 0.5; */
        Matrix4x4.ConstructRotationMatrix(euler, preTransformMat);

        const path = Mesh.GMeshesLocationFolder + `flamingo/`;
        mesh.LoadMesh(gl, path + `flamingo1.gltf`, 0, preTransformMat, true);

        const matName = `mat`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);

        scene.AllMeshesArr.push(mesh);
    }

    //Glowing eye
    {
        const mesh = scene.MeshEye;
        mesh.Name = "Eye";

        mesh.GeneratePlane(gl);
        const s = 0.02;
        mesh.Scale.Set3(s, s, 1);
        //mesh.Position.Set3(-2.493, 1.01, -5.86);

        mesh.Material.bisEmmiter = true;
        mesh.Material.bAdditiveBlend = true;
        //mesh.Material.Brightness = 2.0;
        mesh.Material.AlbedoTexture = GTexturePool.CreateTexture(gl, false, "eye2", true, true, false, null, null);

        scene.AllMeshesArr.push(mesh);
    }

    //const planeSize = GetVec2(3.5, 2.5);
    const planeExtentSize = SceneBase.UniformBuffer.Params.SceneBoundsExtent;
    const woodMaterial = new Material();
    {
        const matName = `woodPlanks`;
        woodMaterial.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
        woodMaterial.TextureScale = 2.0;
    }
    //Front
    {
        scene.MeshWallFront.GeneratePlane(gl);
        scene.MeshWallFront.Scale.Set3(planeExtentSize.x, planeExtentSize.y, 1);
        scene.MeshWallFront.Material = woodMaterial;
        scene.AllMeshesArr.push(scene.MeshWallFront);
    }
    //Walls
    {
        //Wall Left
        const wallLeft = new Mesh();
        wallLeft.GeneratePlane(gl);
        wallLeft.Scale.Set3(planeExtentSize.x, planeExtentSize.y, 1);
        wallLeft.Orientation.z = -Math.PI * 0.5;
        wallLeft.Position.x = -planeExtentSize.x;
        wallLeft.Position.z = -planeExtentSize.z;
        wallLeft.Material = woodMaterial;
        scene.AllMeshesArr.push(wallLeft);

        //Wall Right
        const wallRight = new Mesh();
        wallRight.GeneratePlane(gl);
        wallRight.Scale.Set3(planeExtentSize.x, planeExtentSize.y, 1);
        wallRight.Orientation.z = -wallLeft.Orientation.z;
        wallRight.Position.x = -wallLeft.Position.x;
        wallRight.Position.z = wallLeft.Position.z;
        wallRight.Material = woodMaterial;
        scene.AllMeshesArr.push(wallRight);
    }

    //Kneel
    /* {
        const mesh = new Mesh();
        mesh.GeneratePlane(gl);
        const kneelScale = 0.35;
        mesh.Scale.Set3(planeExtentSize.x * kneelScale, planeExtentSize.y * kneelScale * 0.6, 1);
        mesh.Orientation.x = Math.PI * 0.5;
        mesh.Position.y = -scene.MeshWallFront.Scale.y + 0.05;
        mesh.Position.z = -planeExtentSize.z * 0.5;
        const matName = `redMetal`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
        mesh.Material.AlbedoTexture = GTexturePool.CreateTexture(gl, false, `kneel`, true, true, false, null);

        scene.AllMeshesArr.push(mesh);
    } */

    //Floor
    {
        const mesh = new Mesh();
        mesh.GeneratePlane(gl);
        mesh.Scale.Set3(planeExtentSize.x, planeExtentSize.y, 1);
        mesh.Orientation.x = Math.PI * 0.5;
        mesh.Position.y = -scene.MeshWallFront.Scale.y;
        mesh.Position.z = -planeExtentSize.z;
        const matName = `redMetal`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
        //mesh.Material.TextureScale = 2.0;
        scene.AllMeshesArr.push(mesh);
    }
    //Ceiling
    {
        const mesh = new Mesh();
        mesh.GeneratePlane(gl);
        mesh.Scale.Set3(planeExtentSize.x, planeExtentSize.y, 1);
        mesh.Orientation.x = -Math.PI * 0.5;
        mesh.Position.y = scene.MeshWallFront.Scale.y;
        mesh.Position.z = -planeExtentSize.z;
        const matName = `ceilTiles`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
        mesh.Material.TextureScale = 1.0;
        scene.AllMeshesArr.push(mesh);
    }

    //Painting
    {
        const mesh = scene.MeshPainting;
        mesh.Name = "Painting";
        mesh.GeneratePlane(gl);
        mesh.Scale.Set3(3, 2.0, 1.0);
        const addPaintScale = 0.9;
        mesh.Scale.x *= addPaintScale;
        mesh.Scale.y *= addPaintScale;

        mesh.Position.Set(SceneBase.UniformBuffer.Params.OccluderPlaneCenter);
        SceneBase.UniformBuffer.Params.OccluderPlaneExtent.Set(mesh.Scale);
        SceneBase.UniformBuffer.Params.OccluderPlaneExtent.z = 0.1;

        //const matName = `paper`;
        //mesh.Material.Init(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, true);
        //scene.PaintingTextureInitial = GTexturePool.CreateTexture(gl, false, `whiteDFS`, true, true, false, null, null);

        mesh.Material.bisEmmiter = true;
        scene.AllMeshesArr.push(mesh);
    }

    //Frame Gold
    if (0) {
    } else {
        {
            const refPos = scene.MeshPainting.Position;

            const mesh = new Mesh();

            mesh.Name = "WoodFrame";

            const path = Mesh.GMeshesLocationFolder + `woodFrame/`;
            mesh.bNormalizeScaleAllAxes = true;
            mesh.Orientation.y = Math.PI * 0.5;
            mesh.Orientation.x = Math.PI * 0.5;
            /* mesh.Scale.x = 2.2;
            mesh.Scale.y = 0.1;
            mesh.Scale.z = 2.7; */

            mesh.Scale.Set3(2.04, 0.15, 3.0);

            mesh.LoadMesh(gl, path + `sceneNew.gltf`, 0);

            mesh.Position.Set(refPos);

            const matName = `mat`;
            mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
            mesh.Material.TextureScale = 2.0;

            //mesh.Material.Metalness = 0.5;

            scene.AllMeshesArr.push(mesh);

            {
                const mesh2 = new Mesh();

                mesh2.Name = "GoldFrame";

                mesh2.bNormalizeScaleAllAxes = true;
                mesh2.Orientation.Set(mesh.Orientation);

                /* mesh2.Scale.Set(mesh.Scale);
                mesh2.Scale.y = 1.7;

                mesh2.Scale.x *= 0.910371;
                mesh2.Scale.z *= 0.922724; */

                mesh2.Scale.Set3(1.87, 4.5, 2.79);

                mesh2.LoadMesh(gl, path + `sceneNew.gltf`, 1);

                mesh2.Position.Set(mesh.Position);
                mesh2.Position.z -= 0.2;

                if (1) {
                    mesh2.Material.InitTextures(
                        gl,
                        matName + `DFS`,
                        matName + `NRM`,
                        matName + `RGH_R8`,
                        false,
                        Mesh.GMeshesLocationFolder + `goldFrame/`,
                    );
                    mesh2.Material.Metalness = 0.6;
                } else {
                    mesh2.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false, path);
                    mesh2.Material.Metalness = 0.0;
                }

                mesh2.Material.TextureScale = 2.0;
                scene.AllMeshesArr.push(mesh2);
            }
        }
    }

    //Molding
    //Plinth
    {
        const mesh = new Mesh();
        const path = Mesh.GMeshesLocationFolder + `plinth/`;
        mesh.bNormalizeScaleAllAxes = true;
        mesh.LoadMesh(gl, path + `scene.gltf`, 0);

        const moldSize = scene.FloorPlinthSize;

        mesh.Scale.Set(moldSize);
        mesh.Position.z = -moldSize.z * 0.5;
        mesh.Position.y = -SceneBase.UniformBuffer.Params.SceneBoundsExtent.y + moldSize.y;

        mesh.Orientation.z = -Math.PI;
        //mesh.Scale.Set3(20.0, 20.0, 20.0);

        const matName = `darkWood`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
        //mesh.Material.TextureScale = 2.0;
        scene.AllMeshesArr.push(mesh);
    }
    //Cornice
    {
        const mesh = new Mesh();
        const path = Mesh.GMeshesLocationFolder + `cornice/`;
        mesh.bNormalizeScaleAllAxes = true;
        mesh.LoadMesh(gl, path + `scene.gltf`, 0);

        const moldSize = scene.CeilCorniceSize;

        mesh.Scale.Set(moldSize);
        mesh.Position.z = -moldSize.z * 0.5;
        mesh.Position.y = SceneBase.UniformBuffer.Params.SceneBoundsExtent.y - moldSize.y;

        mesh.Orientation.z = Math.PI;
        //mesh.Scale.Set3(20.0, 20.0, 20.0);

        const matName = `darkWood`;
        mesh.Material.InitTextures(gl, matName + `DFS`, matName + `NRM`, matName + `RGH_R8`, false);
        //mesh.Material.TextureScale = 2.0;
        scene.AllMeshesArr.push(mesh);
    }
}

//======================
// 		SDF DESC
//======================

export function InitSDFDesc(scene: PayneSceneLightSwitch) {
    return (
        /* glsl */ `


	#define PROJECTOR_DECAL
	#define GI_USE_SH
	#define ROPE_USE_SH
	#define USE_SSR

	#ifndef SDF_MAX_DISTANCE
	#define SDF_MAX_DISTANCE 20.0
	#endif

	float sceneSDF(vec3 curPos, bool bRayMeshIntersection, bool bRayMeshIntersection2)
	{
		float curD = SDF_MAX_DISTANCE;
		
		//main painting pos
		{
			//vec3 boxPos = vec3(0.0, 0.0, -1.0);
			vec3 boxPos = SceneBuffer.OccluderPlaneCenter;
			vec3 boxExtent = SceneBuffer.OccluderPlaneExtent;
			curD = min(curD, sdBox(curPos, boxPos, boxExtent));
		}
		
		vec3 sceneExtent = SceneBuffer.SceneBoundsExtent;
		vec3 sceneCenter = SceneBuffer.SceneBoundsCenter;

		//Molding
		{
			const vec3 kFloorPlinthSize = vec3(float(` +
        scene.FloorPlinthSize.x +
        /* glsl */ `), float(` +
        scene.FloorPlinthSize.y +
        /* glsl */ `),
			float(` +
        scene.FloorPlinthSize.z +
        /* glsl */ `)
			);

			vec3 boxPos;
			boxPos.x = 0.0;
			boxPos.y = -sceneExtent.y + kFloorPlinthSize.y;
			boxPos.z = -kFloorPlinthSize.z * 0.5;
			vec3 boxExtent = kFloorPlinthSize * 0.5;
			curD = min(curD, sdBox(curPos, boxPos, boxExtent));


			const vec3 kFloorCorniceSize = vec3(float(` +
        scene.CeilCorniceSize.x +
        /* glsl */ `), float(` +
        scene.CeilCorniceSize.y +
        /* glsl */ `),
			float(` +
        scene.CeilCorniceSize.z +
        /* glsl */ `)
			);

			boxPos.x = 0.0;
			boxPos.y = sceneExtent.y - kFloorCorniceSize.y;
			boxPos.z = -kFloorCorniceSize.z * 0.5;
			boxExtent = kFloorCorniceSize * 0.5;
			curD = min(curD, sdBox(curPos, boxPos, boxExtent));
		}

		//walls
		//front
		{
			/* vec3 pointOnPlane = vec3(0.0, 0.0, 0.0);
			vec3 planeN = vec3(0.0, 0.0, -1.0);
			float d = -dot(pointOnPlane, planeN);
			curD = min(curD, sdPlane(curPos, planeN, d)); */
			curD = min(curD, /* abs */(0.0 - curPos.z));
		}
		//left
		{
			vec3 pointOnPlane = vec3(-sceneExtent.x, 0.0, 0.0);
			vec3 planeN = vec3(1.0, 0.0, 0.0);
			float d = -dot(pointOnPlane, planeN);
			curD = min(curD, sdPlane(curPos, planeN, d));
			//curD = min(curD, abs(-sceneExtent.x - curPos.x));
		}
		//right
		{
			/* vec3 pointOnPlane = vec3(sceneExtent.x, 0.0, 0.0);
			vec3 planeN = vec3(-1.0, 0.0, 0.0);
			float d = -dot(pointOnPlane, planeN);
			curD = min(curD, sdPlane(curPos, planeN, d)); */
			curD = min(curD, /* abs */(sceneExtent.x - curPos.x));
		}
		//floor
		{
			vec3 pointOnPlane = vec3(0, -sceneExtent.y, 0.0);
			vec3 planeN = vec3(0.0, 1.0, 0.0);
			float d = -dot(pointOnPlane, planeN);
			curD = min(curD, sdPlane(curPos, planeN, d));
			//curD = min(curD, /* abs */(-2.5 - curPos.y));
		}
		//ceil
		{
			vec3 pointOnPlane = vec3(0.0, sceneExtent.y, 0.0);
			vec3 planeN = vec3(0.0, -1.0, 0.0);
			float d = -dot(pointOnPlane, planeN);
			curD = min(curD, sdPlane(curPos, planeN, d));
			//curD = min(curD, /* abs */(sceneExtent.y - curPos.y));
		}

		//sdf mesh
		#if 1
		//curD = min(curD, sdCustomMesh(curPos, bRayMeshIntersection));
		curD = min(curD, sdCustomMesh(curPos, SDFTexture, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent, SceneBuffer.SDFMeshUniformScale, bRayMeshIntersection));
		#endif
		

		return curD;
	}

	float SDFComputeShadow(vec3 p, vec3 lightPos)
	{
		//return 1.0;

		float w = 0.2;
		float ph = 1e20;
		float d = length(lightPos - p);
		vec3 l = (lightPos - p) / d;

		float minT = 0.1;
		float maxT = d;
		float res = 1.0;
		float t = minT;

    	for( int i=0; i<24; i++ )
    	{
    	    //float h = sceneSDF(p + l*t);
    	    //float h = sceneSDFShadow(p + l*t, false);
			float h = SDF_MAX_DISTANCE;
    	    h = min(h, sdBox(p + l*t, SceneBuffer.OccluderPlaneCenter, SceneBuffer.OccluderPlaneExtent));
			
			float y = h*h/(2.0*ph);
        	float di = sqrt(h*h-y*y);
        	res = min( res, di/(w*max(0.0,t-y)) );
        	ph = h;
        	t += h;

			if( res<0.0001 || t>maxT ) break;
    	}

		t = minT;
		w = 0.1;

		//Light Cord Handle
		for( int i=0; i<32; i++ )
		{
			//float h = sceneSDF(p + l*t);
			//float h = sceneSDFShadow(p + l*t, false);
			float h = SDF_MAX_DISTANCE;
			vec3 curPos = p + l*t;
			{
				const float handleRad = 0.1;
				//float sdCappedCone( vec3 p, vec3 a, vec3 b, float ra, float rb )
				h = min(h, sdCappedCone(curPos,
					 SceneBuffer.LightSwitchHandlePos + vec3(0.0, 0.325, 0.0),
					 SceneBuffer.LightSwitchHandlePos - vec3(0.0, 0.325, 0.0), 
					 handleRad * 0.7,
					handleRad));
			}
			
			float y = h*h/(2.0*ph);
			float di = sqrt(h*h-y*y);
			res = min( res, di/(w*max(0.0,t-y)) );
			ph = h;
			t += h;

			if( res<0.0001 || t>maxT ) break;
		}

		#if 1 //RayTraced
		{
			int numInstances = int(SceneBuffer.SwitchRopeNumSpheres);
			float radius = SceneBuffer.SwitchRopeSphereRadius;
			for(int i = 0; i < numInstances; i++)
			{
				int offset = i * 3;
				vec3 instancePos = vec3(
					texelFetch(RopePositionsTextureSDF, ivec2(offset + 0, 0), 0).r,
					texelFetch(RopePositionsTextureSDF, ivec2(offset + 1, 0), 0).r,
					texelFetch(RopePositionsTextureSDF, ivec2(offset + 2, 0), 0).r
				);
				bool bIntersection = RaySphereIntersection(p, l, instancePos, radius);
				if(bIntersection)
				{
					return 0.0;
				}
			}
		}
		#endif

		
	#if 1 //SDF MESH
		w = 0.01;
		minT = 0.5;
		t = minT;

		vec4 rayMeshIntersectionRes = RayAABBIntersection(p, l, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent);
		bool bRayMeshIntersection = rayMeshIntersectionRes.x > 0.0;

		for( int i=0; i<32; i++ )
		{
			float h = SDF_MAX_DISTANCE;
			h = sdCustomMesh(p + l*t, SDFTexture, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent, SceneBuffer.SDFMeshUniformScale, bRayMeshIntersection);
			
			float y = h*h/(2.0*ph);
			float di = sqrt(h*h-y*y);
			res = min( res, di/(w*max(0.0,t-y)) );
			ph = h;
			t += h;

			if( res<0.0001 || t>maxT ) break;
		}
	#endif

    	res = clamp( res, 0.0, 1.0 );
	    return res*res*(3.0-2.0*res);

	}


	`
    );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function InitSDFDescPhoneScene(scene: PayneSceneLightSwitch) {
    return /* glsl */ `

	#define SECOND_SDF_MESH
	#define LAMP_LIGHTS
	#define GI_USE_SH
	
	//#define USE_LIGHTPROBES

	#ifndef SDF_MAX_DISTANCE
	#define SDF_MAX_DISTANCE 20.0
	#endif

	float sceneSDF(vec3 curPos, bool bRayMeshIntersection, bool bRayMeshIntersection2)
	{
		float curD = SDF_MAX_DISTANCE;

		//main painting pos
		{
			//vec3 boxPos = vec3(0.0, 0.0, -1.0);
			vec3 boxPos = SceneBuffer.OccluderPlaneCenter;
			vec3 boxExtent = SceneBuffer.OccluderPlaneExtent;
			curD = min(curD, sdBox(curPos, boxPos, boxExtent));
		}

		//table
		{
			curD = min(curD, sdBox(curPos, vec3(0.0, -0.19, 0.0), vec3(3.5, 0.07, 2.65)));
		}
		//tableCloth
		{
			curD = min(curD, sdBox(curPos, vec3(-0.04, -0.11, -1.3), vec3(1.27, 0.02, 1.24)));
		}

		//AO paint on table
		{
			curD = min(curD, sdCapsule(curPos, vec3(1.27, 0.07, -3.19), vec3(1.27, -0.13, -3.19) - vec3(0.0, 0.0, -2.25), 0.17));
		}

		//lamp sphere
		{
			curD = min(curD, sdSphere(curPos, vec3(-4.8, 5.3, -0.17), 0.7));
			curD = min(curD, sdSphere(curPos, vec3(4.8 + 0.85, 5.3, -0.17), 0.7));
		}
		
		//walls
		//front
		{
			/* vec3 pointOnPlane = vec3(0.0, 0.0, 0.0);
			vec3 planeN = vec3(0.0, 0.0, -1.0);
			float d = -dot(pointOnPlane, planeN);
			curD = min(curD, sdPlane(curPos, planeN, d)); */
			curD = min(curD, /* abs */(0.0 - curPos.z));
		}

		//sdf mesh
		#if 1
		/* float distToSDFMeshAABB = sdBox(curPos, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent);
		if(distToSDFMeshAABB < curD) */
		{
			curD = min(curD, sdCustomMesh(curPos, SDFTexture, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent, SceneBuffer.SDFMeshUniformScale, bRayMeshIntersection));
			curD = min(curD, sdCustomMesh(curPos, SDFTexture2, SceneBuffer.SDFMeshBoundsCenter2, SceneBuffer.SDFMeshBoundsExtent2, SceneBuffer.SDFMeshUniformScale2, bRayMeshIntersection2));
		}
		#endif

		//floor
		{
			//curD = min(curD, /* abs */(0.75 + curPos.y));
		}
		

		return curD;
	}

	float SDFComputeShadow(vec3 p, vec3 lightPos)
	{
		float res = 1.0;
		//return res;

		//Compute self-shadow bias
		float bias = 0.0;
		
		float d = length(lightPos - p);
		vec3 l = (lightPos - p) / d;

		float maxT = d;
		
		float w = 0.1;
		float minT = 0.01;
		float t = minT;

		bool bRayMeshIntersection = false;
		{
			vec4 rayMeshIntersectionRes = RayAABBIntersection(p, l, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent * 1.5);
			bRayMeshIntersection = rayMeshIntersectionRes.x > 0.0;
			if(bRayMeshIntersection && rayMeshIntersectionRes.y < 0.0)
			{
				t = rayMeshIntersectionRes.z;
			}
		}
		bool bRayMeshIntersection2 = false;
		{
			vec4 rayMeshIntersectionRes = RayAABBIntersection(p, l, SceneBuffer.SDFMeshBoundsCenter2, SceneBuffer.SDFMeshBoundsExtent2 * 1.5);
			bRayMeshIntersection2 = rayMeshIntersectionRes.x > 0.0;
			if(bRayMeshIntersection2 && rayMeshIntersectionRes.y < 0.0)
			{
				t = min(t, rayMeshIntersectionRes.z);
			}
		}

		
	#if 1 //compute self intersection bias
		float sdf = sdCustomMesh(p, SDFTexture, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent, SceneBuffer.SDFMeshUniformScale, bRayMeshIntersection);
		sdf = min(sdf, sdCustomMesh(p, SDFTexture2, SceneBuffer.SDFMeshBoundsCenter2, SceneBuffer.SDFMeshBoundsExtent2, SceneBuffer.SDFMeshUniformScale2, bRayMeshIntersection2));

		sdf = min(sdf, sceneSDF(p, false, false));

		float selfIntersectThres = 0.01 * SceneBuffer.SDFMeshUniformScale;

		if(sdf < selfIntersectThres)
		{
			bias = abs(sdf) + 0.01 * SceneBuffer.SDFMeshUniformScale;
		}
	#endif

		vec3 boxPos = SceneBuffer.OccluderPlaneCenter;
		vec3 boxExtent = SceneBuffer.OccluderPlaneExtent;

		float ph = 1e20;
    	for( int i=0; i<16; i++ )
    	{
    	    //float h = sceneSDF(p + l*t, bRayMeshIntersection);
			vec3 curPos = p + l*t;
			float h = SDF_MAX_DISTANCE;
			h = sdCustomMesh(curPos, SDFTexture, SceneBuffer.SDFMeshBoundsCenter, SceneBuffer.SDFMeshBoundsExtent, SceneBuffer.SDFMeshUniformScale, bRayMeshIntersection);
			h = min(h, sdCustomMesh(curPos, SDFTexture2, SceneBuffer.SDFMeshBoundsCenter2, SceneBuffer.SDFMeshBoundsExtent2, SceneBuffer.SDFMeshUniformScale2, bRayMeshIntersection2));
			
			//h = min(h, sceneSDF(curPos, false, false));
			h = min(h, sdBox(curPos, boxPos, boxExtent));
			
			h += bias;
			
		#if 1
			res = min( res, h/(w*t) );
		#else
			float y = (i==0) ? 0.0 : h*h/(2.0*ph); 
			//float y = h*h/(2.0*ph);
        	float di = sqrt(h*h-y*y);
        	res = min( res, di/(w*max(0.0,t-y)) );
        	ph = h * 1.1;
		#endif

        	t += h;

			if( res<0.01 || t>maxT ) break;
    	}

		res = clamp( res, 0.0, 1.0 );
	    return res*res*(3.0-2.0*res);

	}

	`;
}
